import { Injectable } from '@angular/core';
import { PrefixService } from '@zaoblako/web/core/services/prefix/prefix.service';
import { NumberPrefixEnum } from '@zaoblako/shared/common/enums/number-prefix.enum';

@Injectable({ providedIn: 'root' })
export class HdPrefixService extends PrefixService  {
  protected prefix = `${NumberPrefixEnum.HD_TASK_PREFIX}-`;
}
